import styled from 'styled-components';
import { Text14Light } from '../../utils/Text/Text.styles';

export const ButtonContainer = styled.button`
  border-radius: 12px;
  border: 1px solid #432181;
  background: linear-gradient(90deg, #1d0f37 0%, #05020b 100%);
  box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 5rem;
  padding-inline: 1.6rem;
  cursor: pointer;
  margin-bottom: 1.2rem;
`;

export const Title = styled(Text14Light)`
  color: #d0b3ff;
  opacity: 0.56;
`;

export const IconWrapper = styled.div`
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -1.2rem;
`;
